export enum StudentReviewResultLoadStatuses {
    PENDING = "PENDING",
    LOADED = "LOADED",
    ERROR = "ERROR",
}

export enum StudentResultLoadFailures {
    /** The share link itself did not resolve: expired, revoked or mistyped. Retrying cannot help. */
    NOT_FOUND = "NOT_FOUND",
    /** The link resolved but something behind it failed to load, so retrying is worth a try. */
    NOT_LOADED = "NOT_LOADED",
}
